import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { BOTTOM_NAVIGATION_HEIGHT } from "const/layout";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const ScrollToTopButton = () => {
  return (
    <ScrollToTopButtonWrapper
      sx={{
        transition: "all 0.2s ease-in-out",
      }}
      onClick={scrollToTop}
    >
      <ArrowUpwardIcon fontSize="large" />
    </ScrollToTopButtonWrapper>
  );
};

export default ScrollToTopButton;

const ScrollToTopButtonWrapper = styled(Stack)(({ theme }) => ({
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",

  height: 40,
  width: 40,

  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
  bottom: `${8 + BOTTOM_NAVIGATION_HEIGHT}px`,
  zIndex: 10,

  color: "white",
  backgroundColor: `${theme.palette.primary.main}dd`,
}));
